import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Product, ProductForm } from '../../models/product';
import { ApiError, Pagination } from '../../models/base';

export const ProductsActions = createActionGroup({
  source: 'Products',
  events: {
    // === FETCH ALL ===
    'Fetch All': emptyProps(),
    'Fetch All Success': props<{ items: Product[] }>(),
    'Fetch All Failure': props<{ error: ApiError }>(),

    // === FETCH PAGINATED ===
    'Fetch Paginated': props<{
      page: number;
      limit: number;
      search?: string;
      sort?: Record<string, 'asc' | 'desc'>;
      dateFrom?: string;
      dateTo?: string;
    }>(),
    'Fetch Paginated Success': props<{ items: Product[]; pagination: Pagination }>(),
    'Fetch Paginated Failure': props<{ error: ApiError }>(),

    // === TOGGLE STATUS ===
    'Toggle Status': props<{ id: number }>(),
    'Toggle Status Success': props<{ product: Product }>(),
    'Toggle Status Failure': props<{ error: ApiError }>(),

    // === CREATE ===
    Create: props<{ product: ProductForm }>(),
    'Create Success': props<{ product: Product }>(),
    'Create Failure': props<{ error: ApiError }>(),

    // === UPDATE ===
    Update: props<{ id: number; changes: Partial<ProductForm> }>(),
    'Update Success': props<{ product: Product }>(),
    'Update Failure': props<{ error: ApiError }>(),

    // === DELETE ===
    Delete: props<{ id: number }>(),
    'Delete Success': props<{ id: number }>(),
    'Delete Failure': props<{ error: ApiError }>(),
  },
});
